import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../../store";
import { usePermissionsContext } from "../../global/permissions";
import { productLanding } from "./product-landing";
import { onboardingLanding } from "./onboarding-landing";

const AuthCheck = () => {
  const { loading: permissionsLoading, hasApplication } = usePermissionsContext();
  const userPromise = useSelector((state: RootState) => state.auth.user);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    if (userPromise instanceof Promise) {
      userPromise.then(resolvedUser => {
        setUser(resolvedUser);
      });
    } else {
      setUser(userPromise); 
    }
  }, [userPromise]);

  if (user === null || permissionsLoading) {
    return null;
  }


  const pendingOAuthCallback = sessionStorage.getItem("email_oauth_callback");
  if (pendingOAuthCallback) {
    return <Navigate to={`/application-settings/email-config/oauth/callback${pendingOAuthCallback}`} replace />;
  }

  const onboardingPath = onboardingLanding(user);
  if (onboardingPath) return <Navigate to={onboardingPath} replace />;
  return <Navigate to={productLanding(hasApplication)} replace />;
};

export default AuthCheck;
